<template>
  <div
    v-if="$store.state.authentification.connectUserID !== evenement.owner_id"
    style="margin-right:10px;"
  >
    <b-tooltip position="is-left" v-bind:label="ownerEvenement">
      <span
        @mouseover="whoIsOwner(evenement.owner_id)"
      >
        <img
          src="@/assets/img/icons/persons-icon.png"
          class="icon"
          alt="icon-share"
        />
      </span>
    </b-tooltip>
  </div>
</template>
<script>
import axios from 'axios'
export default {
  name: 'WhoIsOwner',
  props: {
    evenement: Object
  },
  data () {
    return {
      ownerEvenement: null
    }
  },
  methods: {
    whoIsOwner (id) {
      this.ownerEvenement = 'Loading...'
      axios.defaults.headers.common['Authorization'] =
        'Bearer ' + window.store.getters.userToken
      axios.get(process.env.URL_SSO_API + 'user/' + id).then(response => {
        this.ownerEvenement =
          'Propriétaire : ' +
          response.data.firstname +
          ' ' +
          response.data.lastname
      })
    }
  }
}
</script>
<style scoped>
.icon {
  width: 15px;
  height: 15px;
  vertical-align: center;
}
</style>



// WEBPACK FOOTER //
// src/components/event/components/WhoIsOwner.vue